import { Expose, Transform } from "class-transformer";
import { Model } from "./model";

export class DashboardPeakTimeReport extends Model {
  @Expose({name : 'avgStudentActive'}) averageActiveStudents : number[];
  @Expose({name : 'avgTeacherOnline'}) averageOnlineTeachers : number[];
  @Expose({name : 'dates'})
  @Transform(({value})=>value.sort((a , b)=> new Date(b).getTime()-new Date(a).getTime()))
  dateLabels : string[];
  @Expose({name: 'teacherOnlineChangeRate'}) teacherChangeRate: number;
  @Expose({name: 'studentActiveChangeRate'}) studentChangeRate: number;
}
